'use strict';

export var GuideData = (window.GuideData = (function() {
   var cachedGuide;

   function getGuideFromApi() {
      var params = { revisionid: App.guide_revisionid };
      var guide = Promise.from(api().guides.get(App.guideid, App.langid, params));
      return (cachedGuide = amendGuideData(guide));
   }

   /**
    * Add anything extra to the API data before it is passed on to the consumer
    * Note: Also do some error checking to ensure the data is present.
    */
   function amendGuideData(guidePromise) {
      return guidePromise
         .then(function(guide) {
            // Add step.number property cause it's useful.
            guide.steps.forEach(function(step, index) {
               step.number = index + 1;
            });

            guide.url = App.guideViewUrl;
            return guide;
         })
         .reportErrors();
   }

   function api() {
      return new Dozuki('//' + window.location.host, new Dozuki.http.jquery($));
   }

   return {
      get: function() {
         return cachedGuide || getGuideFromApi();
      },
   };
})());
